import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import { Heading } from '@scentregroup/ui'
import style from './index.scss'

export type LinkContent = {
  text: string
  url: string
}

export interface LinkSectionPropsType {
  heading: LinkContent
  links?: LinkContent[]
}

export const LinkSection = ({
  heading,
  links,
}: LinkSectionPropsType): ReactElement => (
  <div className={style.linkSection}>
    <Link to={heading.url} className={style.link}>
      <Heading type="small" className={style.footerHeading}>
        {heading.text}
      </Heading>
    </Link>
    {links && links.length > 0 && (
      <div className={style.footerLinks}>
        {links.map((link, index) => (
          <Link to={link.url} key={index} className={style.link}>
            {link.text}
          </Link>
        ))}
      </div>
    )}
  </div>
)
